import ModelUtil from '@leverege/model-util';
import GeoLayerModel from "./GeoLayerModel.js";
const TYPE = 'molten.googleMapRenderer.GeoPointModel';

/**
 * This represents geo layers that have point objects. It will contain
 * options for the layer as whole, such as visibility options and selection
 * and rollover options.
 */
function create(layerName, name, objectType, extend) {
  return {
    ...GeoLayerModel.create(layerName, name, objectType),
    type: TYPE,
    symbolizer: null,
    // TODO: Add Text options
    scale: {
      normal: 1.0,
      alert: 1.0,
      rollover: 1.0,
      selected: 1.0
      // scaleWithZoom : false,
      // scaleFromZoom : 5,
      // scaleToZoom : 10,
      // scaleToFactor : 1,
      // scaleFromFactor : 0,
    },
    iconSize: {
      override: false,
      size: null,
      sizeUnits: 'pixels'
    },
    accuracy: {
      showAccuracyOn: 'selected',
      lineStyle: {
        color: {
          type: 'colorizer.Value',
          color: 'rgb(22, 97, 215)'
        },
        width: 1,
        style: 'default',
        opacity: 1
      },
      fillStyle: {
        color: {
          type: 'colorizer.Value',
          color: 'rgb(22, 97, 215)'
        },
        opacity: 0.5
      }
    },
    ...extend
  };
}
function update(model, context) {
  const {
    attribute,
    blueprint,
    modelName
  } = context;
  let nModel = model;
  if (modelName) {
    if (model.name !== modelName) {
      nModel = GeoLayerModel.setName(nModel, modelName);
    }
  } else if (blueprint.namePlural !== model.name) {
    nModel = GeoLayerModel.setName(nModel, blueprint.namePlural);
  }
  if (attribute && attribute.name !== model.attrName) {
    nModel = GeoLayerModel.setAttributeName(nModel, attribute.name);
  }
  return nModel;
}
export default {
  ...GeoLayerModel,
  TYPE,
  create,
  update,
  ...ModelUtil.createAllValue('scale/normal', 'NormalScale'),
  ...ModelUtil.createAllValue('scale/alert', 'AlertScale'),
  ...ModelUtil.createAllValue('scale/rollover', 'RolloverScale'),
  ...ModelUtil.createAllValue('scale/selected', 'SelectedScale'),
  ...ModelUtil.createAllValue('scale/scaleWithZoom', 'ScalesWithZoom'),
  ...ModelUtil.createAllValue('scale/scaleFromZoom', 'ScaleFromZoom'),
  ...ModelUtil.createAllValue('scale/scaleToZoom', 'ScaleToZoom'),
  ...ModelUtil.createAllValue('scale/scaleToFactor', 'ScaleToFactor'),
  ...ModelUtil.createAllValue('scale/scaleFromFactor', 'ScaleFromFactor'),
  ...ModelUtil.createAllValue('symbolizer'),
  ...ModelUtil.createAllValue('iconSize/override', 'HasOverrideIconSize'),
  ...ModelUtil.createAllValue('iconSize/size', 'OverrideIconSize'),
  ...ModelUtil.createAllValue('iconSize/sizeUnits', 'OverrideIconSizeUnits'),
  ...ModelUtil.createAllValue('accuracy/showAccuracyOn', 'ShowAccuracyOn', null, {
    defaultValue: 'selected'
  }),
  ...ModelUtil.createAllValue('accuracy/lineStyle/color', 'LineColor'),
  ...ModelUtil.createAllValue('accuracy/lineStyle/width', 'LineWidth'),
  ...ModelUtil.createAllValue('accuracy/lineStyle/style', 'LineStyle'),
  ...ModelUtil.createAllValue('accuracy/lineStyle/pattern', 'LinePattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('accuracy/lineStyle/dashArray', 'LineDashArray', {
    validate: ModelUtil.isNumberArray
  }),
  ...ModelUtil.createAllValue('accuracy/lineStyle/opacity', 'LineOpacity'),
  ...ModelUtil.createAllValue('accuracy/lineStyle/cap', 'LineCap'),
  ...ModelUtil.createAllValue('accuracy/lineStyle/join', 'LineJoin'),
  ...ModelUtil.createAllValue('accuracy/fillStyle/color', 'FillColor'),
  ...ModelUtil.createAllValue('accuracy/fillStyle/pattern', 'FillPattern', {
    validate: ModelUtil.isStringTrimAndNull
  }),
  ...ModelUtil.createAllValue('accuracy/fillStyle/opacity', 'FillOpacity')
};